import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import emailIcon from "@iconify/icons-mdi/email";
import { InlineIcon } from "@iconify/react";

interface OcEmailInputFieldProps {
  value: string;
  setValue: (value: string) => void;
  error: boolean;
  setError: (error: boolean) => void;
  helperText: string;
  setHelperText: (text: string) => void;
  label?: string;
}

export const OcEmailInputField: React.FC<OcEmailInputFieldProps> = ({
  value,
  setValue,
  error,
  setError,
  helperText,
  setHelperText,
  label,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    return () => {
      setValue("");
      setError(false);
      setHelperText("");
    };
    // eslint-disable-next-line
  }, [setValue, setError, setHelperText]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const pointer = e.target.selectionStart;
    const element = e.target;
    window.requestAnimationFrame(() => {
      element.selectionStart = pointer;
      element.selectionEnd = pointer;
    });
    setValue(e.target.value);
  };

  return (
    <TextField
      id="email-input-field"
      label={label ? label : t("MY_HR_EMAIL")}
      variant="outlined"
      fullWidth
      value={value}
      onChange={handleChange}
      error={error}
      helperText={error && helperText}
      onFocus={() => {
        setError(false);
        setHelperText("");
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <InlineIcon
              icon={emailIcon}
              style={{
                width: "24px",
                height: "24px"
              }}
              color={theme.palette.gray60.main}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default OcEmailInputField;
